/**
 * Enum representing the color context for a component, such as a link or button.
 */
export var Context;
(function (Context) {
    Context["None"] = "";
    Context["Dark"] = "dark";
    Context["Light"] = "light";
    Context["Primary"] = "primary";
    Context["Secondary"] = "secondary";
    Context["White"] = "white";
})(Context || (Context = {}));
//# sourceMappingURL=Context.js.map